class OpaPermissions {
  static readonly ANALYTICS_CREATE = 'analytics.create';
  static readonly ANALYTICS_READ = 'analytics.read';

  static readonly API_CLIENT_CREATE = 'apiClient.create';
  static readonly API_CLIENT_DELETE = 'apiClient.delete';
  static readonly API_CLIENT_READ = 'apiClient.read';
  static readonly API_CLIENT_UPDATE = 'apiClient.update';

  static readonly BILLING_UPDATE = 'billing.update';

  static readonly CLIP_CREATE = 'clip.create';
  static readonly CLIP_DELETE = 'clip.delete';
  static readonly CLIP_DOWNLOAD = 'clip.download';
  static readonly CLIP_READ = 'clip.read';
  static readonly CLIP_UPDATE = 'clip.update';

  static readonly CONTACT_CREATE = 'contact.create';
  static readonly CONTACT_DELETE = 'contact.delete';
  static readonly CONTACT_READ = 'contact.read';
  static readonly CONTACT_UPDATE = 'contact.update';

  static readonly CONTROL_VIEW = 'control.view';

  static readonly CONTENT_DESTINATION_CREATE = 'contentDestination.create';
  static readonly CONTENT_DESTINATION_DELETE = 'contentDestination.delete';
  static readonly CONTENT_DESTINATION_DOWNLOAD = 'contentDestination.download';
  static readonly CONTENT_DESTINATION_READ = 'contentDestination.read';
  static readonly CONTENT_DESTINATION_UPDATE = 'contentDestination.update';

  static readonly CUE_PRIVATE_CREATE = 'cue.private.create';
  static readonly CUE_PRIVATE_DELETE = 'cue.private.delete';
  static readonly CUE_PRIVATE_READ = 'cue.private.read';
  static readonly CUE_PRIVATE_UPDATE = 'cue.private.update';

  static readonly CUE_PUBLIC_CREATE = 'cue.public.create';
  static readonly CUE_PUBLIC_DELETE = 'cue.public.delete';
  static readonly CUE_PUBLIC_READ = 'cue.public.read';
  static readonly CUE_PUBLIC_UPDATE = 'cue.public.update';

  static readonly CUE_SHARED_CREATE = 'cue.shared.create';
  static readonly CUE_SHARED_DELETE = 'cue.shared.delete';
  static readonly CUE_SHARED_READ = 'cue.shared.read';
  static readonly CUE_SHARED_UPDATE = 'cue.shared.update';

  static readonly CUSTOMER_CREATE = 'customer.create';
  static readonly CUSTOMER_READ = 'customer.read';
  static readonly CUSTOMER_READ_ANY = 'customer.readAny';
  static readonly CUSTOMER_UPDATE = 'customer.update';

  static readonly DESTINATION_GROUP_CREATE = 'destinationGroup.create';
  static readonly DESTINATION_GROUP_DELETE = 'destinationGroup.delete';
  static readonly DESTINATION_GROUP_READ = 'destinationGroup.read';
  static readonly DESTINATION_GROUP_UPDATE = 'destinationGroup.update';

  static readonly ENCODER_CREATE = 'encoder.create';
  static readonly ENCODER_DELETE = 'encoder.delete';
  static readonly ENCODER_LOGS = 'encoder.logs';
  static readonly ENCODER_MOVE = 'encoder.move';
  static readonly ENCODER_MOVE_FROM_ANY = 'encoder.moveFromAny';
  static readonly ENCODER_NETWORK = 'encoder.network';
  static readonly ENCODER_READ = 'encoder.read';
  static readonly ENCODER_UPDATE = 'encoder.update';

  static readonly ENCODER_CHANNEL_CREATE = 'encoderChannel.create';
  static readonly ENCODER_CHANNEL_DELETE = 'encoderChannel.delete';
  static readonly ENCODER_CHANNEL_READ = 'encoderChannel.read';
  static readonly ENCODER_CHANNEL_UPDATE = 'encoderChannel.update';

  static readonly ENCODER_CHANNEL_USER_READ = 'encoderChannelUser.read';
  static readonly ENCODER_CHANNEL_USER_UPDATE = 'encoderChannelUser.update';

  static readonly ENCODER_EVENT_CREATE = 'encoderEvent.create';
  static readonly ENCODER_EVENT_DELETE = 'encoderEvent.delete';
  static readonly ENCODER_EVENT_DOWNLOAD = 'encoderEvent.download';
  static readonly ENCODER_EVENT_READ = 'encoderEvent.read';
  static readonly ENCODER_EVENT_UPDATE = 'encoderEvent.update';

  static readonly ENCODER_PRESET_CREATE = 'encoderPreset.create';
  static readonly ENCODER_PRESET_DELETE = 'encoderPreset.delete';
  static readonly ENCODER_PRESET_READ = 'encoderPreset.read';
  static readonly ENCODER_PRESET_UPDATE = 'encoderPreset.update';

  static readonly ENCODER_SUPPORT_READ = 'encoderSupport.read';

  static readonly ENCODER_VERSION_UPDATE = 'encoderVersion.update';

  static readonly DECODER_LOGS = 'decoder.logs';

  // NOTE: Currently not being used. Keeping for now as we expect it might be used in the future
  static readonly FEED_CREATE = 'feed.create';
  static readonly FEED_DELETE = 'feed.delete';
  static readonly FEED_READ = 'feed.read';
  static readonly FEED_UPDATE = 'feed.update';

  static readonly HARDWARE_CREATE = 'hardware.create';
  static readonly HARDWARE_DELETE = 'hardware.delete';
  static readonly HARDWARE_READ = 'hardware.read';
  static readonly HARDWARE_UPDATE = 'hardware.update';

  static readonly PERMISSION_READ = 'permission.read';

  static readonly PLAYER_CONFIG_CREATE = 'playerConfig.create';
  static readonly PLAYER_CONFIG_DELETE = 'playerConfig.delete';
  static readonly PLAYER_CONFIG_READ = 'playerConfig.read';
  static readonly PLAYER_CONFIG_UPDATE = 'playerConfig.update';

  static readonly PLAYLIST_CREATE = 'playlist.create';
  static readonly PLAYLIST_DELETE = 'playlist.delete';
  static readonly PLAYLIST_READ = 'playlist.read';
  static readonly PLAYLIST_UPDATE = 'playlist.update';

  static readonly POST_CREATE = 'post.create';
  static readonly POST_DELETE = 'post.delete';
  static readonly POST_READ = 'post.read';
  static readonly POST_UPDATE = 'post.update';

  static readonly ROLE_LIST_INTERNAL = 'role.listInternal';

  static readonly SAVED_VIDEO_CREATE = 'savedVideo.create';
  static readonly SAVED_VIDEO_DELETE = 'savedVideo.delete';
  static readonly SAVED_VIDEO_DOWNLOAD = 'savedVideo.download';
  static readonly SAVED_VIDEO_READ = 'savedVideo.read';
  static readonly SAVED_VIDEO_UPDATE = 'savedVideo.update';

  static readonly SCHEDULE_CREATE = 'schedule.create';
  static readonly SCHEDULE_DELETE = 'schedule.delete';
  static readonly SCHEDULE_READ = 'schedule.read';
  static readonly SCHEDULE_UPDATE = 'schedule.update';

  static readonly SEARCH_CLIP_READ = 'search.clip.read';
  static readonly SEARCH_READ = 'search.read';
  static readonly SEARCH_SITE_READ = 'search.site.read';

  static readonly SITE_CREATE = 'site.create';
  static readonly SITE_DELETE = 'site.delete';
  static readonly SITE_READ = 'site.read';
  static readonly SITE_UPDATE = 'site.update';
  static readonly SITE_VIEW = 'site.view';

  static readonly SOCIAL_MEDIA_CREATE = 'socialMedia.create';
  static readonly SOCIAL_MEDIA_DELETE = 'socialMedia.delete';
  static readonly SOCIAL_MEDIA_READ = 'socialMedia.read';
  static readonly SOCIAL_MEDIA_UPDATE = 'socialMedia.update';

  static readonly SOFTWARE_ENCODER_DELETE = 'softwareEncoder.delete';

  static readonly SUDO = 'sudo';
  static readonly SUDO_ADMIN = 'sudoAdmin';

  static readonly SYSTEM_LOG_READ = 'systemLog.read';

  static readonly TEAM_VIEWER_READ = 'teamViewer.read';

  static readonly TRIAL_CREATE = 'trial.create';
  static readonly TRIAL_DELETE = 'trial.delete';
  static readonly TRIAL_READ = 'trial.read';
  static readonly TRIAL_UPDATE = 'trial.update';

  static readonly USER_CREATE = 'user.create';
  static readonly USER_DELETE = 'user.delete';
  static readonly USER_READ = 'user.read';
  static readonly USER_UPDATE = 'user.update';

  static readonly USER_INVITE_CREATE = 'userInvite.create';
  static readonly USER_INVITE_READ = 'userInvite.read';
  static readonly USER_INVITE_RESEND = 'userInvite.resend';
  static readonly USER_INVITE_REVOKE = 'userInvite.revoke';

  static readonly WEB_CHANNEL_CREATE = 'webChannel.create';
  static readonly WEB_CHANNEL_DELETE = 'webChannel.delete';
  static readonly WEB_CHANNEL_READ = 'webChannel.read';
  static readonly WEB_CHANNEL_UPDATE = 'webChannel.update';

  static readonly WEB_PRESET_CREATE = 'webPreset.create';
  static readonly WEB_PRESET_DELETE = 'webPreset.delete';
  static readonly WEB_PRESET_READ = 'webPreset.read';
  static readonly WEB_PRESET_UPDATE = 'webPreset.update';
}

export default OpaPermissions;
